import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent'

export function initNewRelic(env) {
  if (process.env.VUE_APP_NEW_RELIC_ENABLED !== 'true') return

  // CW-2239: New Relic is exempt from GPC suppression.
  // It operates under a data processor / service provider agreement and
  // collects no PII beyond session-scoped performance data.

  const options = {
    init: {
      distributed_tracing: { enabled: true },
      privacy: { cookies_enabled: false },
      ajax: {
        deny_list: [],
        enabled: true
      },
      session_replay: {
        enabled: false,
        sampling_rate: 10.0,
        error_sampling_rate: 100.0
      },
      feature_flags: ['spa', 'ajax']
    },
    info: {
      beacon: 'bam.nr-data.net',
      errorBeacon: 'bam.nr-data.net',
      licenseKey: process.env.VUE_APP_NEW_RELIC_LICENSE_KEY,
      applicationID: process.env.VUE_APP_NEW_RELIC_APP_ID,
      sa: 1
    },
    loader_config: {
      accountID: process.env.VUE_APP_NEW_RELIC_ACCOUNT_ID,
      trustKey: process.env.VUE_APP_NEW_RELIC_TRUST_KEY,
      agentID: process.env.VUE_APP_NEW_RELIC_APP_ID,
      licenseKey: process.env.VUE_APP_NEW_RELIC_LICENSE_KEY,
      applicationID: process.env.VUE_APP_NEW_RELIC_APP_ID
    }
  }

  try {
    window.newrelic = new BrowserAgent(options)
    // Set environment once here — avoids the duplicate setCustomAttribute call
    // that existed in main.js (was set both in init options and after init).
    window.newrelic.setCustomAttribute('environment', env)
  } catch (error) {
    console.error('Failed to initialize New Relic:', error)
  }
}

export function trackNewRelicRoute(to, from) {
  if (!window.newrelic) return
  try {
    const interaction = window.newrelic.interaction().setName(`Route: ${to.name || to.path}`)
    const attrs = {
      routeName: to.name || null,
      routePath: to.fullPath,
      fromPath: from.fullPath,
      timestamp: new Date().toISOString()
    }
    Object.entries(attrs).forEach(([k, v]) => {
      if (v !== null && v !== undefined) interaction.setAttribute(k, v)
    })
    interaction.save()
    window.newrelic.setPageViewName(to.name || to.path)
    window.newrelic.addPageAction('route_change', {
      routeName: to.name,
      routePath: to.fullPath,
      fromPath: from.fullPath
    })
  } catch (e) {
    // fail silently
  }
}
